import { Row } from 'antd';
import ButtonComponent from 'components/atoms/ButtonComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
// import Paragraph from 'components/atoms/Paragraph';
import TranslateText from 'components/hoc/TranslateText';
import StatementWrapper from 'components/molecules/StatementWrapper';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import paymentMethods from 'styles/images/paymentMethods.png';

interface IObchodniPodminky {
    setShowTerms?: React.Dispatch<React.SetStateAction<boolean>>;
}

const ObchodniPodminky: React.FC<IObchodniPodminky> = ({ setShowTerms }) => {
    const history = useHistory();

    useEffect(() => {
        window.parent.scrollTo(0, 0);
    }, []);

    return (
        <StatementWrapper pageTitle="">
            {/* <Paragraph text="PODMINKY_SLUZBY" strong={true} /> */}
            <h3 id="top">
                <TranslateText>PODMINKY_SLUZBY_ZU</TranslateText>
            </h3>

            <div className="section-podminky-sluzby">
                <ol
                    style={{
                        paddingLeft: '24px'
                    }}
                >
                    <li className="podminka">
                        <TranslateText>
                            Centrální depozitář cenných papírů poskytne na žádost majitele účtu, který je vedený
                            evidenci nezařazených účtů (tj. v evidenci účtů převzatých ze Střediska cenných papírů),
                            služby zápisu změny osobních a adresních údajů a zápis nebo změnu čísla bankovního účtu.
                            Změnit údaje lze pouze údaji předanými CDCP bankovní identitou
                        </TranslateText>
                    </li>
                    <li className="podminka">
                        <TranslateText>
                            Podmínkou poskytnutí služby je řádné podání žádosti, identifikace prostřednictvím bankovní
                            identity (BankID) a uhrazení poplatku za tuto službu předem. Žadatel je povinen v žádosti
                            uvést číslo nezařazeného účtu, který je veden na jeho jméno
                        </TranslateText>
                    </li>
                    <li className="podminka">
                        <TranslateText>
                            Poplatek lze uhradit pouze prostřednictvím platební brány použitím spotřebitelské platební
                            karty vydané v Evropské Unii nebo pomocí platebních tlačítek. Žadatel je povinen uhradit
                            poplatek před poskytnutím služby.
                        </TranslateText>
                    </li>
                    <li className="podminka">
                        <TranslateText>
                            Žadatel je povinen poskytnout centrálnímu depozitáři nezbytnou součinnost, zejména
                            poskytnout osobní údaje nezbytné k vyřízení žádosti. Žadatel může být vyzván k doložení
                            dalších údajů. Pokud žadatel neposkytne údaje potřebné k vyřízení žádosti po jejím
                            zaplacení, nebude žádost dokončena. V případě nedokončené žádosti se platba nevrací.
                        </TranslateText>
                    </li>
                    <li className="podminka">
                        <TranslateText>
                            Žadatel souhlasí s tím, že mu budou informace o vyřízení žádosti a potvrzení o úhradě
                            poskytnuty pouze v elektronické podobě. Tyto dokumenty si žadatel sám stáhne využitím
                            webového odkazu během doby platnosti, která činí 30 dní.
                        </TranslateText>
                    </li>
                    <li className="podminka">
                        <TranslateText>
                            Pokud používáte bankovní identitu u více bank, použijte pro podání žádosti a stažení
                            výsledku vždy stejnou Bankovní identitu.
                        </TranslateText>
                    </li>
                    <li className="podminka">
                        <TranslateText>
                            Poskytovatelem používané platební brány je společnost ComGate Payments, a.s. Kontaktní údaje
                            pro účely případných reklamací nebo dotazů k platbám:
                        </TranslateText>
                        <br />
                        <br />
                        <TranslateText>ComGate Payments, a.s.</TranslateText>
                        <br />
                        <TranslateText>Gočárova třída 1754 / 48b, Hradec Králové</TranslateText>
                        <br />
                        <TranslateText>E-mail: platby-podpora@comgate.cz</TranslateText>
                        <br />
                        <TranslateText>Tel: +420 228 224 267 </TranslateText>
                        <br />
                    </li>
                </ol>

                <div className="comgate-images">
                    <img src={paymentMethods} width={520} alt="Payment methods" />
                </div>
            </div>

            <Row className="statement-buttons-row">
                <ButtonComponent
                    htmlType="button"
                    buttontext="ZPET"
                    onClick={() => (setShowTerms ? setShowTerms(false) : history.goBack())}
                />
            </Row>
        </StatementWrapper>
    );
};

export default ObchodniPodminky;
